<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import { useExporting } from '~/composables/exporting'
import AuthScope from '~/enums/auth-scope'
import Export from '~/enums/export'

const model = defineModel<boolean>()

const { exportData } = useExporting()

const isLoading = ref(false)

function close (): void {
  model.value = false
}

async function download (): Promise<void> {
  isLoading.value = true

  await exportData(AuthScope.Admin, Export.PaidOrdersAndUsersStatistics, 'Оплаченные заказы и пользователи.xlsx')

  isLoading.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Экспорт оплаченных заказов и&nbsp;пользователей
    </template>

    <BasicButton color="green" :is-loading="isLoading" title="Скачать таблицу (XLSX)" @click="download" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
